import React from "react";
import Slider from "react-slick";
import { useStyles } from "./TheyTrustStyle";
import { Box } from "@mui/material";

export default function SimpleSlider() {
  const classes = useStyles();
  var settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    autoplay: true, // Enable auto-play
    autoplaySpeed: 1500, // Set auto-play speed in milliseconds
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const CardsData = [
    "Alterea-blue.png",
    "Eiffage_logo.svg.png",
    "Fleury-Michon.png",
    "NPF-logo.png",
    "LVMH.svg",
    "NOVAM.png",
    "Oteis.jpg",
    "Poma.png",
    "Suez_logo.png",
    // "SNCF_Reseau_logo.png",
    "Zenth.svg",
    "NGE_logo.png",
    // "SNCF_logo.png",
    "UNIFER_logo.png",
    "grtgaz-logo.png",
    "Vinci-Grand.png",
  ];

  return (
    <Box className={classes.SliderContainer}>
      <Slider {...settings} className={classes.Slider}>
        {CardsData.map((item, index) => (
          <div key={index} className={classes.LogoBox}>
            <img alt="" src={item} className={classes.LogoImage} />
          </div>
        ))}
      </Slider>
    </Box>
  );
}
